'use strict';

$.fn.popupBanner = function() {
  const main = $(this);
  const closeBtn = main.find('#popup-banner__close');
  closeBtn.on('click', (e) => {
    e.preventDefault();
    main.remove();
  });
}

const formIsValid = (form) => {
  const inputs = form.find('[data-validate');
  const regexes = {
    'default': /.{3,}/,
    'email': /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
    'phone': /^[0-9\+\s]+$/
  }
  let pass = true;

  inputs.each(function() {
    const obj = $(this);
    const validateType = obj.attr('data-validate');
    const value = obj.val();
    const isCheckbox = obj.is('[type="checkbox"]');
    if (isCheckbox) {
      if (obj.prop('checked')) {
        obj.parents('.formItem:first').removeClass('formItem--error');
      } else {
        pass = false;
        obj.parents('.formItem:first').addClass('formItem--error');
      }
    } else {
      if (!value.match(regexes[validateType])) {
        pass = false;
        obj.parents('.formItem:first').addClass('formItem--error');
      } else {
        obj.parents('.formItem:first').removeClass('formItem--error');
      }
    }
  });

  return pass;

}

$.fn.contactModal = function(){
  const main = $(this);
  const id = main.attr('id');
  const modal = $(`[data-modal="${id}"]`);
  const form = modal.find('form');

  let data = form.serialize();
  let method = form.attr('method');
  let action = form.attr('action');
  
  form.prepend('<button style="position:absolute; top: -10000000px;"></button>');
  form.on('submit', function(e){
    e.preventDefault();
    const obj = $(this);
    data = obj.serialize();
    method = obj.attr('method');
    action = obj.attr('action');

    const site_key = obj.find('[name="site_key"]').val() || undefined;

    if (!formIsValid(obj)) {
      return false;
    }
    
    if( site_key) {
      grecaptcha.ready(function() {
        grecaptcha.execute(site_key, {action: 'submit'}).then(function(token) {
          data+= `&token=${token}`;
          postForm();
        });
      });
    } else {
      postForm();
    }
    
  });

  function postForm() {
    $.ajax({
      method,
      url: action,
      data,
      dataType: 'html',
      success: function(response) {
        modal.find('.contactModal__form').html(response);
      }
    });
  }

  modal.on('click', (e) => {
    if ($(e.target).is('form') || $(e.target).is('#modalClose') || $(e.target).is('.contactModal__wrapper'))  {
      e.preventDefault();
      modal[0].scrollTop = 0;
      modal.hide();
    } 
  });

  main.on('click', (e) => {
    e.preventDefault();
    modal.show();
  })
}

$.fn.notification = function () {
  const main = $(this);
  main.find('.mdi-close').on('click', (e) => {
    e.preventDefault();
    main.remove();
  });
}

$.fn.comparisonNotification = function() {
  const main = $(this);
  main.find('.comparison-notification__close').on('click', (e) => {
    e.preventDefault();
    main.remove();
  });
}

$.fn.loadMore = function() {
  const main = $(this);
  const output = main.find('[data-loadMore="output"]')
  const button = main.find('[data-loadMoreUrl]');
  const url = button.attr('data-loadMoreUrl');
  
  const loadData = () => {
    $.ajax({
      url: url,
      type: 'GET',
      success: function(response) {
        output.append(response);
      }
    });
  };

  button.on('click', (e) => {
    e.preventDefault();
    loadData();
  });

} 

$.fn.comparisonBar = function() {
  const main = $(this);
  const options = {};
  let debouncer;

  const bindEvents = () => {
    $(window).on('scroll', (e) => {
      options.top = main.offset().top;
      options.height = main.outerHeight();
      options.bottom = options.top + options.height - 84;
      options.scrollTop = $(window).scrollTop();
      checkStatus();
    }).trigger('scroll');
  };

  const checkStatus = () => {
    if (options.scrollTop > options.bottom & !options.isStuck) {
      stick();
    }
    else if (options.scrollTop < options.bottom & options.isStuck) {
      unstick();
    }
  };

  const stick = () => {
    options.isStuck = true;
    const template = `
      <div class="comparisonToolbar"><div class="inline">${main.html()}</div></div>
    `;
    console.log('appending');
    $('body').append(options.elem = $(template));
  };

  const unstick = () => {
    options.isStuck = false;
    options.elem.remove();
  };

  bindEvents();
}

$.fn.productsSlider = function() {
  const main = $(this);
  const slides = main.find('[class*="col"]');
  const smBreak = 640;
  const mdBreak = 1000;
  let slidesCount = 0;
  let page = 0;
  let maxPages = 0;

  let prevArrow;
  let nextArrow;

  main.addClass('productSlider');
  main.append(prevArrow = $('<div class="productSlider__prev"><span class="mdi mdi-chevron-left"></span></div>'));
  main.append(nextArrow = $('<div class="productSlider__next"><span class="mdi mdi-chevron-right"></span></div>'));

  prevArrow.on('click', function(e){
    e.preventDefault();
    page--;
    showPage();
  });

  nextArrow.on('click', function(e){
    e.preventDefault();
    page++;
    showPage();
  });

  const setSlidesCount = () => {
    const winWidth = $(window).width();
    let tmpSlides = 4;
    if (winWidth <= smBreak) {
      tmpSlides = 2;
    }
    else if (winWidth <= mdBreak) {
      tmpSlides = 3;
    }
    if( slidesCount !== tmpSlides) {
      slidesCount = tmpSlides;
      page = 0;
      maxPages = Math.ceil(slides.length  / slidesCount);
      showPage();
    }
  };

  const showPage = () => {
    const minIndex = page * slidesCount;
    const maxIndex = (page + 1) * slidesCount;
    slides.hide();
    slides.each(function(index){
      if (index >= minIndex && index <= maxIndex - 1) {
        $(this).show();
      }
    });

    if (maxPages == 1) {
      prevArrow.hide();
      nextArrow.hide();
    } else {
      if (page > 0) {
        prevArrow.show();
      }
      else {
        prevArrow.hide();
      }

      if (page + 1 < maxPages) {
        nextArrow.show();
      } else {
        nextArrow.hide();
      }
    }
  };

  $(window).on('resize.productSlider', function(){
    setSlidesCount();
  }).trigger('resize.productSlider');
}

$.fn.mobileHeader = function() {
  const main = $(this);
  const menuBtn = main.find('#header-menu-button');
  const searchBtn = main.find('#header-search-button');
  let searchState = false;
  
  menuBtn.on('click', (e) => {
    e.preventDefault();
    $('.menu:first').toggleClass('menu--active');
  });

  searchBtn.on('click', (e) => {
    e.preventDefault();
    if (searchState) {
      main.find('.header__logo').show();
      main.find('.header__search').hide();
    } else {
      main.find('.header__logo').hide();
      main.find('.header__search').show();
    }
    searchState = !searchState;
  });
}

$.fn.accordion = function() {
  const main = $(this);
  const accordionHeaders = main.find('.accordion__header');
  accordionHeaders.on('click', function() {
    const obj = $(this);
    obj.parent().toggleClass('open');
  });
}

$.fn.badgeTip = function() {
  const main = $(this);
  main.on('click', function () {
    var obj = $(this);
    obj.toggleClass('open');
  });
}

$.fn.cardTitleHeights = function() {
  const main = $(this);
  const cardTitles = main.find('.card__title');
  const cardTitleTexts = cardTitles.find('span');
  function checkHeights() {
    const arr = [];
    cardTitles.each(function() {
      const obj = $(this);
      obj.css('min-height', '')
      arr.push(obj[0].offsetHeight);
    });
    const maxHeight = Math.max(...arr);
    cardTitles.each(function() {
      $(this).css('min-height', maxHeight + 'px');
    });
  }
  checkHeights();
  cardTitleTexts.each(function() {
    const obj = $(this);
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        checkHeights();
      });
    });
    observer.observe(obj[0]);
  });
}

$(document).ready(function(){
  $('[data-badge]').each(function() {
    $(this).badgeTip();
  });
});